const onResizeCallbacks = [];
const destroyTimers = {};
const stateReady = {};

const $window = $(window);
const mobile = Symbol('mobile');
const verticalTablet = Symbol('verticalTablet');
const desktop = Symbol('desktop');

let currentAdaptive = desktop; // т.к. верстка изначально под десктоп

$('.reports').each(function each(widgetsIndex, Section) {
    const $section = $(Section);
    const $titlesRow = $section.find('.reports__headers');
    const $contentsRow = $section.find('.reports__contents');

    const $titlesColumns = $titlesRow.children('.col');
    const $titles = $titlesColumns.find('.block-title');

    const $contentsColumns = $contentsRow.children('.col');

    onResizeCallbacks.push(onResize);
    destroyTimers[widgetsIndex] = 0;
    stateReady[widgetsIndex] = false;

    function onResize() {
        stateReady[widgetsIndex] = false;

        if (mobile === currentAdaptive || verticalTablet === currentAdaptive) {
            $contentsColumns.each(function eachContentColumn(columnIndex, Column) {
                const titleIndex = columnIndex;

                $(Column).prepend($titles[titleIndex]);
            });

            initSlider();
        }

        else if (desktop === currentAdaptive) {
            $titlesColumns.each(function eachTitleColumn(columnIndex, Column) {
                const titleIndex = columnIndex;

                $(Column).prepend($titles[titleIndex]);
            });

            destroySlider();
        }
    }

    const prevArrow = NLMK.generateSlickArrow('left', 'prev');
    const nextArrow = NLMK.generateSlickArrow('right', 'next');

    function destroySlider() {
        clearTimeout(destroyTimers[widgetsIndex]);
        if (!stateReady[widgetsIndex]) {
            destroyTimers[widgetsIndex] = setTimeout(function() {
                destroySlider();
            }, 100);
            return;
        }
        $contentsRow.slick('unslick');
        $contentsRow.find('.slick-slider').slick('reinit');
    }

    function initSlider() {
        $contentsRow
            .on('init', function(evt, Slick) {
                stateReady[widgetsIndex] = true;
            })
            .on('beforeChange', function() {
                stateReady[widgetsIndex] = true;
            })
            .slick({
                infinite: false,
                prevArrow,
                nextArrow,
                mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 0,
                        settings: {
                            dots: true,
                        },
                    },
                    {
                        breakpoint: NLMK.mediaQueries.verticalTablet.min - 1,
                        settings: {
                            arrows: true,
                            dots: true,
                            variableWidth: true,
                        },
                    },
                ],
            });
    }
});

setTimeout(() => {
    $window.on('resize', onResize);
}, 100);

onResize();

function onResize() {
    let adaptive;

    if (innerWidth < NLMK.mediaQueries.verticalTablet.min) {
        adaptive = mobile;
    }

    else if (innerWidth < NLMK.mediaQueries.horizontalTablet.min) {
        adaptive = verticalTablet;
    }

    else {
        adaptive = desktop;
    }

    if (currentAdaptive !== adaptive) {
        currentAdaptive = adaptive;

        onResizeCallbacks.forEach(callback => callback());
    }
}



// WEBPACK FOOTER //
// ./js/main/module/section-reports.js